// extracted by mini-css-extract-plugin
export var adornment = "styles-module--adornment--ff019";
export var error = "styles-module--error--08d76";
export var fullWidth = "styles-module--fullWidth--151d3";
export var fullWidthError = "styles-module--fullWidthError--d6e54";
export var headingWrapper = "styles-module--headingWrapper--7a5be";
export var links = "styles-module--links--45261";
export var mtitle = "styles-module--mtitle--cf82f";
export var privacyPolicy = "styles-module--privacyPolicy--ce2b9";
export var success = "styles-module--success--6ea39";
export var unsubscribe = "styles-module--unsubscribe--80167";
export var update = "styles-module--update--daaa3";
export var wrapper = "styles-module--wrapper--eeadc";